module.exports = __webpack_public_path__ + "static/media/booking2.758c3a87.jpg";